<div class="table-wrapper">
  <div class="table-container">
    <table class="crud-table">
      <thead>
        <tr>
          <th>{{ "CRUD.F11.FEEDER_NAME" | translate }}</th>
          <th>{{ "CRUD.F11.FEEDER_NUMBER" | translate }}</th>
          <th>{{ "CRUD.F11.INJECTION_SUBSTATION" | translate }}</th>
          <th>{{ "CRUD.F11.MAIN_FEEDER" | translate }}</th>
          <th>{{ "CRUD.F11.TRANSMISSION_STATION" | translate }}</th>
          <th>{{ "CRUD.F11.REGIONS" | translate }}</th>
          <th>{{ "CRUD.F11.NAMEPLATE_RATING" | translate }}</th>
          <th></th>
        </tr>
      </thead>
      <tbody>
        <tr *ngFor="let f11 of feeders11" (click)="selectF11(f11)" data-bs-toggle="modal" data-bs-target="#editAddModal">
          <td>{{f11.name | hasValue}}</td>
          <td>{{f11.number | hasValue}}</td>
          <td>{{f11.substation?.name | hasValue}}</td>
          <td>{{f11.feeder33?.name | hasValue}}</td>
          <td>{{f11.transmissionStation?.name | hasValue}}</td>
          <td>{{f11.region?.name | hasValue}}</td>
          <td>{{f11.nameplateRating | hasValue}}</td>
          <td>
            <div class="d-flex icons-col">
              <div>
                <svg width="15" height="15" viewBox="0 0 15 15" fill="none" xmlns="http://www.w3.org/2000/svg">
                  <path d="M6.50536 4.73283C6.50536 4.33333 6.82911 4.00931 7.2286 4.00931C7.6281 4.00931 7.95185 4.33333 7.95185 4.73283V7.76471L9.95724 8.64627C10.3226 8.80705 10.4883 9.23334 10.3275 9.59838C10.1667 9.96342 9.74041 10.1291 9.37537 9.96862L6.97458 8.91315C6.70032 8.81034 6.50536 8.54592 6.50536 8.23584V4.73283ZM0.897691 4.94447C0.876909 4.88294 0.864058 4.81759 0.860503 4.74951L0.751128 2.74001C0.73062 2.34216 1.03687 2.00309 1.43472 1.98286C1.83258 1.96235 2.17164 2.2686 2.19187 2.66645L2.21211 3.03833C2.5101 2.65486 2.84745 2.30367 3.21863 1.99051C3.71 1.57598 4.26809 1.22243 4.88688 0.946527C6.6552 0.157658 8.57419 0.159572 10.2468 0.800238C11.9025 1.43461 13.3192 2.69434 14.1132 4.43232C14.1343 4.47005 14.1521 4.50997 14.1663 4.55154C14.9281 6.30318 14.9191 8.19729 14.2858 9.85104C13.6514 11.5067 12.3917 12.9234 10.6537 13.7172C10.546 13.7775 10.4246 13.8091 10.3012 13.8088C9.90174 13.8088 9.57798 13.485 9.57798 13.0855C9.57798 12.7711 9.77869 12.5037 10.059 12.4041C10.2692 12.3076 10.4708 12.1999 10.663 12.0815C10.6849 12.0634 10.7081 12.0465 10.7327 12.0306C11.0425 11.8305 11.337 11.6013 11.6033 11.3459C11.6208 11.3292 11.6392 11.3134 11.658 11.2989C12.223 10.7383 12.6555 10.0668 12.9353 9.3367C13.4455 8.00506 13.4485 6.48037 12.8231 5.07872C12.1978 3.67708 11.0622 2.66016 9.73248 2.15075C8.40083 1.64079 6.87614 1.63778 5.4745 2.26286C4.99658 2.47575 4.55105 2.75494 4.15106 3.0922C3.88145 3.3197 3.63699 3.56962 3.41961 3.83841L3.51395 3.82665C3.91016 3.77825 4.27082 4.06044 4.31922 4.45665C4.36762 4.85286 4.08543 5.21353 3.68922 5.26193L1.69148 5.50802C1.31797 5.55341 0.976167 5.3054 0.897691 4.94447ZM8.50173 14.3223C9.07267 14.2583 9.34502 13.5859 8.97916 13.1421C8.82302 12.9527 8.58568 12.8594 8.34232 12.8846C7.91685 12.9324 7.4911 12.9316 7.06591 12.881C6.81052 12.8507 6.56141 12.9554 6.40446 13.1591C6.06649 13.6084 6.33473 14.2466 6.89173 14.3171C7.42712 14.3811 7.96579 14.3825 8.50173 14.3223ZM3.88774 13.2102C4.1043 13.3541 4.37364 13.3705 4.60743 13.2578C5.10754 13.0101 5.15348 12.3169 4.68973 12.0066C4.33946 11.7755 4.00231 11.4881 3.71602 11.1819C3.45406 10.903 3.02477 10.8742 2.72863 11.1165C2.65215 11.1792 2.58935 11.2569 2.54411 11.3449C2.49887 11.4328 2.47216 11.5291 2.46562 11.6278C2.45909 11.7264 2.47287 11.8254 2.50611 11.9186C2.53936 12.0117 2.59136 12.097 2.65891 12.1692C3.02367 12.5575 3.44258 12.9168 3.88774 13.2102ZM1.0489 9.41327C1.12875 9.67139 1.34203 9.85952 1.60699 9.91038C2.14129 10.0096 2.59164 9.50459 2.43086 8.98561C2.30344 8.57545 2.22605 8.15819 2.19461 7.72971C2.15742 7.2285 1.64199 6.91978 1.18125 7.11912C0.900425 7.24627 0.731167 7.52354 0.751675 7.83197C0.790503 8.36955 0.888941 8.89838 1.0489 9.41327Z" fill="#17171A"/>
                </svg>
              </div>
              <div>
                <svg
                  width="15"
                  data-bs-toggle="modal" data-bs-target="#deleteF11"
                  height="15"
                  (click)="$event.stopPropagation(); onDeleteF11(f11)"
                  viewBox="0 0 22 22"
                  xmlns="http://www.w3.org/2000/svg"
                >
                  <path
                    fill-rule="evenodd"
                    clip-rule="evenodd"
                    d="M11 22C17.0751 22 22 17.0751 22 11C22 4.92487 17.0751 0 11 0C4.92487 0 0 4.92487 0 11C0 17.0751 4.92487 22 11 22ZM11 20C15.9706 20 20 15.9706 20 11C20 6.02944 15.9706 2 11 2C6.02944 2 2 6.02944 2 11C2 15.9706 6.02944 20 11 20ZM6 11C6 10.4477 6.44772 10 7 10H15C15.5523 10 16 10.4477 16 11C16 11.5523 15.5523 12 15 12H7C6.44772 12 6 11.5523 6 11Z"
                    fill="#17171A"
                  />
                </svg>
              </div>
            </div>
          </td>
        </tr>
      </tbody>
    </table>
    <div class="pagination">
      <app-asset-list-pagination
        [pageFromList]="currentPage"
        (pageChanged)="onPageChange($event)"
        [totalItems]="count"
      >
      </app-asset-list-pagination>
    </div>
  </div>
</div>

<div
  class="modal fade"
  id="deleteF11"
  tabindex="-1"
  aria-hidden="true"
>
  <div class="modal-dialog modal-dialog-centered">
    <div class="modal-content delete-modal-content" (click)="$event.stopPropagation()">
      <div class="modal-header delete-modal-header">
        <h5 class="modal-title" id="exampleModalLongTitle">
          {{ "CRUD.ARE_YOU_SURE_DELETE" | translate}} {{ "CRUD.F11.SUB_FEEDER" | translate}}?
        </h5>
      </div>
      <div class="modal-footer delete-modal-footer">
        <button
          type="button"
          data-bs-toggle="modal" data-bs-target="#deleteF11"
          class="btn btn-primary"
          data-bs-dismiss="modal"
          (click)="deleteF11()"
        >
          {{ "COMMON.DELETE" | translate }}
        </button>
      </div>
    </div>
  </div>
</div>

<div
  class="modal fade"
  id="editAddModal"
  tabindex="-1"
  aria-hidden="true"
>
  <div class="modal-dialog modal-dialog-centered">
    <div class="modal-content edit-modal-content" (click)="$event.stopPropagation()">
      <div class="modal-header edit-modal-header">
        <h5 class="modal-title" id="f11ModalTitle">
          {{ (isEditMode ? "CRUD.F11.EDIT_SUB_FEEDER" : "CRUD.F11.NEW_SUB_FEEDER") | translate }}
        </h5>
      </div>
      <div class="modal-body edit-modal-body">
        <span>{{ "CRUD.NAME" | translate }}</span>
        <label for="nameInput">
          <input id="nameInput" type="text" [(ngModel)]="updatedName" [placeholder]="'Sub Feeder Name' | translate" />
        </label>
        <span>{{ "CRUD.NUMBER" | translate }}</span>
        <label for="numberInput">
          <input id="numberInput" type="text" [(ngModel)]="updatedNumber" [placeholder]="'Sub Feeder Number' | translate" />
        </label>
        <span>{{ "Is connected directly to TS?" | translate }}</span>
        <label for="isDirectSelect">
          <select id="isDirectSelect" [(ngModel)]="isDirectToTs" (change)="onDirectToTsChange()">
            <option [ngValue]="null" disabled hidden>{{ "Is connected directly to TS?" | translate }}</option>
            <option [ngValue]="true">{{ "Yes" | translate }}</option>
            <option [ngValue]="false">{{ "No" | translate }}</option>
          </select>
        </label>
        <span *ngIf="isDirectToTs == true">{{ "CRUD.F11.TRANSMISSION_STATION" | translate }}</span>
        <label *ngIf="isDirectToTs == true" for="tsSelect">
          <select id="tsSelect" [(ngModel)]="updatedTsId">
            <option [value]="null" disabled hidden>{{ "CRUD.F11.TRANSMISSION_STATION" | translate }}</option>
            <option *ngFor="let ts of transmissionStations" [value]="ts.id">
              {{ ts.name | hasValue }}
            </option>
          </select>
        </label>
        <span *ngIf="isDirectToTs == false">{{ "CRUD.F11.INJECTION_SUBSTATION" | translate }}</span>
        <app-dropdown-search *ngIf="isDirectToTs == false && substations.length > 0"
          [items]="substations"
          [label]="!isEditMode ? 'CRUD.F11.INJECTION_SUBSTATION' : ''"
          id="substation-dropdown"
          [selectedItemId]="updatedSsId ?? null"
          (selectedIdChange)="selectSs($event || 0)"
        >
        </app-dropdown-search>
        <span *ngIf="isDirectToTs == false">{{ "CRUD.F11.MAIN_FEEDER" | translate }}</span>
        <app-dropdown-search *ngIf="isDirectToTs == false"
          [items]="feeders33"
          id="feeder33-dropdown"
          [label]="!isEditMode ? 'CRUD.F11.MAIN_FEEDER' : ''"
          [selectedItemId]="updatedF33Id ?? null"
          (selectedIdChange)="selectF33($event || 0)"
        >
        </app-dropdown-search>
        <span>{{ "CRUD.F11.REGION" | translate }}</span>
        <app-dropdown-search *ngIf="regions.length > 0"
          [items]="regions"
          [label]="!isEditMode ? 'CRUD.F11.REGION' : ''"
          id="regions-dropdown"
          [selectedItemId]="updatedRegionId ?? null"
          (selectedIdChange)="selectRegion($event || 0)"
        >
        </app-dropdown-search>
        <span>{{ "CRUD.F11.NAMEPLATE_RATING" | translate }}</span>
        <label for="nameplateRatingSelect">
          <select id="nameplateRatingSelect" [(ngModel)]="updatedNameplateRating">
            <option [value]="null" disabled hidden>{{ "CRUD.F11.NAMEPLATE_RATING" | translate }}</option>
            <option *ngFor="let nr of nameplateRatingOptions" [value]="nr">
              {{ nr | hasValue }}
            </option>
          </select>
        </label>
      </div>
      <div class="modal-footer edit-modal-footer">
        <div>
          <button #closeAddModal class="cancel" data-bs-dismiss="modal">
            {{ "COMMON.CANCEL" | translate }}
          </button>
        </div>
        <div>
          <button class="save" (click)="save()">
            {{ "COMMON.SAVE" | translate }}
          </button>
        </div>
      </div>
    </div>
  </div>
</div>


<ng-template #filterTemplate>
  <div class="crud-filter">
    <div class="filters-wrapper">
      <div class="search-bar">
        <img
          src="assets/icons/search.svg"
          alt="Search icon"
          class="search-icon"
        />
        <input
          (keydown.enter)="onSearch()"
          [(ngModel)]="searchText"
          type="text"
          class="search-input"
          [placeholder]="'COMMON.SEARCH' | translate"
        />
      </div>
    </div>
    <button (click)="download()">Download</button>
  </div>
</ng-template>
